import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@projectobelisk/uikit/components/feedback/empty";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardCheck } from "lucide-react";

export const Route = createFileRoute("/_app/call-center/scorecards")({
  staticData: { title: "Scorecards", breadcrumb: "Scorecards" },
  component: Scorecards,
});

function Scorecards() {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <ClipboardCheck />
        </EmptyMedia>
        <EmptyTitle>No scorecards yet</EmptyTitle>
        <EmptyDescription>
          Define scorecards to evaluate agent performance on calls.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
